<template>
  <ul class="mt-3 pagination justify-content-center pagination-no-border">
    <!-- Botão Anterior -->
    <li class="page-item prev-page" :class="{ disabled: currentPage === 1 }">
      <a class="page-link" aria-label="Previous" @click="changePage(currentPage - 1)">
        <i class="tim-icons icon-double-left" aria-hidden="true"></i>
      </a>
    </li>

    <!-- Botões numerados para cada página -->
    <li class="page-item" v-for="page in totalPagesArray" :key="page" :class="{ active: currentPage === page }">
      <a class="page-link" @click="changePage(page)">
        {{ page }}
      </a>
    </li>

    <!-- Botão Próximo -->
    <li class="page-item next-page" :class="{ disabled: currentPage === totalPages }">
      <a class="page-link" aria-label="Next" @click="changePage(currentPage + 1)">
        <i class="tim-icons icon-double-right" aria-hidden="true"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Paginacao",
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    scrollTarget: {
      type: String,
      default: null, // Pode passar o seletor do elemento que você quer rolar
    },
  },
  computed: {
    totalPagesArray() {
      return Array.from({ length: this.totalPages }, (v, i) => i + 1);
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit('page-changed', page);
        this.scrollToTop();
      }
    },
    scrollToTop() {
      // Checar se existe um alvo de rolagem definido
      if (this.scrollTarget) {
        const targetElement = document.querySelector(this.scrollTarget);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Caso contrário, rolar para o topo da página
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style scoped></style>